import { render, staticRenderFns } from "./home-promo.vue?vue&type=template&id=ce9e866a"
import script from "./home-promo.vue?vue&type=script&lang=js"
export * from "./home-promo.vue?vue&type=script&lang=js"
import style0 from "./home-promo.vue?vue&type=style&index=0&id=ce9e866a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports